import {DesignChecker} from "./designChecker";

export const checkers: DesignChecker[] = [];

export const registerChecker = (check: DesignChecker) => checkers.push(check);
